"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _childProcess = _interopRequireDefault(require("child_process"));
var _stripFinalNewline = _interopRequireDefault(require("strip-final-newline"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var TEN_MEBIBYTE = 1024 * 1024 * 10;
var exec = function(command, args, stdin, cwd) {
    return new Promise(function(resolve, reject) {
        var stdout = "";
        var stderr = "";
        var spawnOptions = {
            maxBuffer: TEN_MEBIBYTE,
            cwd: cwd
        };
        var process = _childProcess.default.spawn(command, args, spawnOptions);
        // All of these handlers can close the Promise, so guard against rejecting it twice.
        var promiseAlreadyRejected = false;
        process.on("close", function(code) {
            if (!promiseAlreadyRejected) {
                promiseAlreadyRejected = true;
                if (code !== 0) {
                    return reject(Error(stderr));
                } else {
                    return resolve((0, _stripFinalNewline).default(stdout));
                }
            }
        });
        if (stdin) {
            process.stdin.on("error", function(err) {
                if (!promiseAlreadyRejected) {
                    promiseAlreadyRejected = true;
                    return reject(err);
                }
            });
            process.stdin.setEncoding("utf-8");
            process.stdin.write(stdin);
            process.stdin.end();
        }
        process.stdout.setEncoding("utf-8");
        process.stdout.on("data", function(data) {
            stdout += data;
        });
        process.stderr.on("data", function(data) {
            stderr += data;
        });
    });
};
var _default = exec;
exports.default = _default;
